module.exports = __webpack_public_path__ + "static/media/icon-grid.f86a7a8b.svg";